const theme = {
  font: "'Noto Sans JP', sans-serif;",
  lightGray: "#E6E6E6",
  orange: "#EB6E4B",
  orangeHover: "#ed9a82",
  white: "#FFFFFF",
  darkGray: "#48484A",
  darkGrayHover: "#85858f",
  gray: "#F1F2F1",
};
export default theme;
